import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'

export const viewSearchResultsSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_search_results'),
  search_term: z.string(),
})
